<template>
    <div class="spa">


        <div v-if="isLoading" class="d-flex justify-content-center">
            <loader></loader>
        </div>
        <div v-else>
            <div class="row d-flex justify-content-center">
                <div class="col-24 mb-4 d-flex justify-content-center">
                    <h3 class="text-center">Who would like to book the Mud Room?</h3>
                </div>
            </div>
            <div class="row mb-4 justify-content-center">
                <div class="col-24 col-xl-17">
                    <div class="d-flex justify-content-center flex-row">
                        <div class="px-3" v-for="(guest, gi) in guests" v-bind:key="gi">
                            <label class="mud-name">
                                <input type="checkbox" v-model="guest.mudAccess" />
                                {{guest.firstName}}
                            </label>




                        </div>
                    </div>
                </div>
            </div>

            <div class="row justify-content-center mb-4">
                <div class="col-24 col-xl-12">

                    <info-box v-bind:type="'alert'">

                        <template v-slot:body>
                            <p>A minimum of 2 guests must be in the mud room.</p>

                        </template>
                    </info-box>



                </div>
            </div>

            <div class="row justify-content-center">
                <div class="col-24 col-xl-10 bg-white has-shadow p-5 text-start">
                    <h3>Booking</h3>

                    <div class="booking-selection">
                        <label class="mb-2">Names</label>

                        <div v-for="(guest, gi) in selectedGuests">
                            <input type="text" class="form-control mb-2" readonly v-bind:value="guest.firstName" />
                        </div>
                        <div v-if="!hasCapacity" class="mb-2">
                            <info-box v-bind:type="'alert'">

                                <template v-slot:body>
                                    <p>Please select a minimum of 2 guests.</p>

                                </template>
                            </info-box>
                        </div>


                        <div v-if="availableTimes == null || !availableTimes.length" class="mb-2">

                            <info-box v-bind:type="'error'">

                                <template v-slot:body>
                                    <p>Sorry, we have no availability.</p>

                                </template>
                            </info-box>
                        </div>

                    </div>


                    <div class="booking-selection" v-if="hasCapacity && (availableTimes!= null && availableTimes.length)">
                        <label class="mb-2">Entry Time</label>

                        <select class="form-select mb-2" v-model="selectedTime">
                            <option disabled="disabled" value="">Please select...</option>
                            <option v-for="(item, ai) in availableTimes" v-bind:value="ai">{{formatTime(item.StartDateTime)}}</option>

                        </select>

                    </div>
                </div>

            </div>


            <div class=" g-0 actions">

                <div class="row mt-8 d-flex ">

                    <div class="col-12 d-flex justify-content-start">
                        <button class="btn btn--transparent btn--back" type="button" v-on:click="onClose()">
                            Cancel
                        </button>

                    </div>


                    <div class="col-12 d-flex justify-content-end" v-if="!isLoading">
                        <button class="btn btn--slate-blue btn--continue d-xl-block" v-bind:disabled="!hasCapacity && selectedAvailability != null" type="button" v-on:click="onSubmit()">
                            Done
                        </button>

                    </div>
                </div>
            </div>


        </div>

    </div>

</template>

<script>
    import spaapi from '@/shared/api/spa';
    import { store } from '../store/index';
    import InfoBox from '@/shared/components/InfoBox.vue';
    import Loader from '@/shared/components/Loader.vue';

    import { _ } from 'vue-underscore';


    export default {
        name: 'SpaAddOnMud',
        props: {
            addOn: Object,
            isDay: Boolean
        },
        components:
        {
            InfoBox,
            Loader
        },
        data() {
            return {
                guests: [],
                isLoading: false,
                selectedTime: '',
                internalAvailaiblity: null

            }
        },
        mounted() {
            let o = this;
            this.isLoading = true;

            let appointments = null;

            if (this.isDay) {
                appointments = this.search.spaDay.Extras?.filter(item => item.SystemType == "APPOINTMENT" && item.ModalType != 'TREATMENTS').flatMap(function (item) {
                    return item.Codes.map(function (innerItem) {
                        return innerItem.Code;
                    })
                });
            } else {
                appointments = this.configuration.SpaTreatments.Extras?.filter(item => item.SystemType == "APPOINTMENT" && item.ModalType != 'TREATMENTS').flatMap(function (item) {
                    return item.Codes.map(function (innerItem) {
                        return innerItem.Code;
                    })
                });
            }


            let extrasPayload = {
                date: moment(this.search.date).format("YYYY-MM-DD"),

                appointmentExtras: appointments
            };


            spaapi.getExtras(extrasPayload, t => {

                o.internalAvailaiblity = t;


                for (let i = 0; i < this.search.guests.length; i++) {
                    let guest = this.search.guests[i];

                    this.guests.push({
                        guestIndex: i,
                        firstName: guest.firstName,
                        mudAccess: true
                    })

                }

                o.isLoading = false;


            });
        },
        computed: {
            selectedAvailability() {
                let availableTimes = this.availableTimes;

                if (availableTimes != null) {
                    let selectedItem = availableTimes[+(this.selectedTime)];
                    return selectedItem;
                }
                return null;
            },
            configuration() {
                return store.getters.configuration;
            },
            activeCode() {
                if (this.hasCapacity) {
                    return this.addOn.content.Codes.find(item => item.Guests = this.selectedGuests.length);
                }
                return null;
            },
            availableTimes() {
                if (this.hasCapacity) {
                    let result = [];
                    let code = this.activeCode.Code;
                    let availabileTime = this.internalAvailaiblity.AddonAppointments.find(item => item.Key == code);
                    let guestMaxArrivalTime, bandEnd, bandEndTime, dayEndTime;
                    
                    if (this.isDay) {
                        guestMaxArrivalTime = _.max(this.search.guests.map(item => moment.utc(item.spaDayArrivalTime.selectedItem.EndDateTime)));
                        bandEnd = this.search.spaDay.bookingDetails.TimeBands.find(item => item.BandNumber == this.search.spaDay.Band)?.EndTime;


                        bandEndTime = moment.utc(bandEnd, "HH:mm")
                        dayEndTime = moment.utc(this.search.date).add(bandEndTime.hour(), 'h').add(bandEndTime.minutes(), 'm');

                    }

                    for (let ai = 0; ai < availabileTime.Items.length; ai++) {
                        let a = availabileTime.Items[ai];

                        let startTime = moment.utc(a.StartDateTime); // i think we need to remove the duration here..

                        let endTime = moment.utc(a.EndDateTime);
                        if (this.isDay) {
                            //After arrival
                            if (startTime < guestMaxArrivalTime) {
                                continue;
                            }

                            if (endTime > dayEndTime) {
                                continue;
                            }
                        }

                        //Not during dining
                        if (this.search?.restaurant != null) {
                         
                            let duration = this.search?.restaurant?.duration ?? 120;
                            let diningAllocation = this.search?.restaurant?.selectedTime?.TimeSlot;
                            if (duration != null && diningAllocation != null) {

                                let minTime = moment.utc(diningAllocation).add(-duration, 'm');
                                let maxTime = moment.utc(diningAllocation).add(duration, 'm');

                                if (startTime.isBetween(minTime, maxTime) || endTime.isBetween(minTime, maxTime)) {
                                    continue;
                                }


                            }
                        }

                        //not during spa garden
                        let canInclude = true;
                        for (var gi = 0; gi < this.search.guests.length; gi++) {
                            let guest = this.search.guests[gi];
                            if (guest.spaArrivalTime != null) {
                                let startGardenTime = moment.utc(guest.spaArrivalTime.StartDateTime);
                                let endGardenTime = moment.utc(guest.spaArrivalTime.EndDateTime);


                                if (startTime.isSame(startGardenTime) ||
                                    startTime.isBetween(startGardenTime, endGardenTime) ||
                                    endTime.isSame(endGardenTime) ||
                                    endTime.isBetween(startGardenTime, endGardenTime)) {
                                    canInclude = false;
                                    break;
                                }
                            }
                        }
                        if (!canInclude) {
                            continue;
                        }


                        //flatten treatments
                        let treatmentGuests = this.search.guests.filter(item => item.startTime?.TreatmentTimes != null);

                        if (treatmentGuests != null && treatmentGuests.length) {
                            let flattenedTreatments = this.search.guests.flatMap(function (item) {
                                return item.startTime.TreatmentTimes;
                            });

                            for (var fi = 0; fi < flattenedTreatments.length; fi++) {
                                var fTreatment = flattenedTreatments[fi];

                                let fTreatmentStart = moment.utc(fTreatment.StartTime);
                                let fTreatmentEnd = moment.utc(fTreatment.EndTime);

                                if (startTime.isSame(fTreatmentStart) ||
                                    startTime.isBetween(fTreatmentStart, fTreatmentEnd) ||
                                    endTime.isSame(fTreatmentEnd) ||
                                    endTime.isBetween(fTreatmentStart, fTreatmentEnd)) {
                                    canInclude = false;
                                    break;
                                }

                            }

                            if (!canInclude) {
                                continue;
                            }
                        }

                        let extrasTreatments = this.search.selectedTreatmentExtras;
                        if (extrasTreatments != null && extrasTreatments.length) {
                            let flattenedExtras = extrasTreatments.map(function (item) {
                                return item.time;
                            });


                            for (var fie = 0; fie < flattenedExtras.length; fie++) {
                                var fTreatmentExtra = flattenedExtras[fie];

                                let fExtraTreatmentStart = moment.utc(fTreatmentExtra.TreatmentTimes[0].StartTime);
                                let fExtraTreatmentEnd = moment.utc(fTreatmentExtra.TreatmentTimes[0].EndTime);

                                if (startTime.isSame(fExtraTreatmentStart) ||
                                    startTime.isBetween(fExtraTreatmentStart, fExtraTreatmentEnd) ||
                                    endTime.isSame(fExtraTreatmentEnd) ||
                                    endTime.isBetween(fExtraTreatmentStart, fExtraTreatmentEnd)) {
                                    canInclude = false;
                                    break;
                                }

                            }

                            if (!canInclude) {
                                continue;
                            }
                        }


                        result.push(a);
                    }

                    return result;

                }
                return null
            },
            search() {
                return store.getters.search;
            },
            selectedGuests() {
                let guests = this.guests.filter(item => item.mudAccess);
                return guests;
            },
            hasCapacity() {
                return this.selectedGuests.length >= 2;
            },

        },

        methods: {
            onClose() {
                this.$parent.$emit('close');
            },
            onSubmit() {

                this.trackAddOnSelection();
                if (this.selectedAvailability == null) {
                    this.$parent.$emit('close');
                    return;
                }

                let payload = {
                    guestIndexes: this.selectedGuests.map(function (item) { return item.guestIndex; }),
                    code: this.activeCode,
                    selection: this.selectedAvailability,
                    addOn: this.addOn
                }

                store.dispatch('selectMudExtras', payload).then(() => {
                    this.$parent.$emit('close');

                });
            },

            formatTime(dateTime) {
                let date = moment(dateTime);
                return date.format("HH:mm");
            },


            trackAddOnSelection() {

                if (this.$gtm.enabled()) {

                    let item = {
                        'item_id': this.activeCode.Code,
                        'item_name': this.activeCode.DisplayPrice,
                        'item_list_name': 'Spa Add On',
                        'item_variant': this.activeCode.Guests + ' Guests',
                        'price': this.selectedAvailability.ActualPrice
                    };

                    window.dataLayer?.push({
                        'pageURL': '/spa/treatment/add-ons',
                        'event': 'add_to_cart',
                        'ecommerce': {
                            'item_list_name': 'Spa Add Ons',
                            'items': [item]
                        }
                    });
                }

            }

        },
        watch: {
            guests: {
                handler: function (val, oldVal) {
                    this.selectedTime = '';

                },
                deep: true
            }
        },


    }
</script>

<style scoped>
    .mud-name {
        display: flex;
        flex-direction: row;
        align-items: center;
        font-size: 16px;
        font-weight: bold;
        font-family: 'Montserrat'
    }

        .mud-name input[type=checkbox] {
            width: 30px;
            height: 30px;
            margin-right: 8px;
        }

    .booking-selection label {
        font-size: 14px;
        font-weight: bold;
        font-family: 'Montserrat'
    }
</style>